// extracted by mini-css-extract-plugin
export default {"input":"input_input__SZKM4","underinput":"input_underinput__wKgTe","label":"input_label__ygqqb","amount":"input_amount__GEztS","amountCurrency":"input_amountCurrency__y+4jk"};